import React from 'react';
import Navbar from '../../Components/Navbar/Navbar';

const Home = () => {
    return (
        <>
            <Navbar></Navbar>
            <h1>Deshi Agro Foods</h1>
            <h2>welcome to page</h2>


        </>
    );
};

export default Home;